module.exports = __webpack_public_path__ + "img/Carousel_2.dd8e5479.jpg";